/**
 * Datos crudos en JSON.
 *
 * No es un campo para el usuario final: aparece en configuraciones y en campos
 * de extension. Se edita como texto y solo emite cuando el JSON es valido, para
 * que un tipeo a medio escribir no destruya la configuracion guardada.
 */

import { useEffect, useState } from 'react';

import { areaClass } from '@/components/fields/controls';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import type { FieldInputProps } from '@/components/fields/types';

function aTexto(valor: unknown): string {
  if (valor === null || valor === undefined) return '';
  if (typeof valor === 'string') return valor;
  return JSON.stringify(valor, null, 2);
}

export function JsonField({ id, meta, value, onChange, readonly, invalid, describedBy }: FieldInputProps) {
  const [texto, setTexto] = useState(() => aTexto(value));
  const [errorSintaxis, setErrorSintaxis] = useState<string | null>(null);
  const idError = `${id}-json-error`;

  useEffect(() => {
    setTexto(aTexto(value));
  }, [value]);

  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  return (
    <>
      <textarea
        id={id}
        rows={5}
        spellCheck={false}
        className={areaClass(invalid || errorSintaxis !== null, 'font-mono text-xs')}
        value={texto}
        aria-invalid={invalid || errorSintaxis !== null || undefined}
        aria-describedby={[describedBy, errorSintaxis === null ? null : idError].filter(Boolean).join(' ') || undefined}
        onChange={(evento) => {
          const nuevo = evento.target.value;
          setTexto(nuevo);
          if (nuevo.trim() === '') {
            setErrorSintaxis(null);
            onChange(null);
            return;
          }
          try {
            onChange(JSON.parse(nuevo));
            setErrorSintaxis(null);
          } catch (error) {
            setErrorSintaxis(error instanceof Error ? error.message : 'JSON inválido.');
          }
        }}
      />
      {errorSintaxis !== null && (
        <p id={idError} className="mt-1 text-xs text-danger">
          JSON inválido: {errorSintaxis}. Los cambios no se guardan hasta que sea válido.
        </p>
      )}
    </>
  );
}
